'use strict';
define(['./navigation/Breakpoint', './util', './Constant'], function (breakpoint, utils, Constant) {
    var STRIPELENGTHTWO = 2,
        HOLD_TIME = 12,
        TRANSITION_TIME = 1.3,
        LOGIN = 'Login',
        BASKET = 'Basket',
        AGEVERIFY = 'AgeVerify',
        PREV = 'prev',
        NEXT = 'next';

    return {
        initHdrSiteStripeCarousel: function (storeId) {
            var stripe = document.querySelectorAll('.navigation-sitestripe'),
                headerEl = document.querySelector('.navigation-common-hdr-main');
            if (stripe.length === STRIPELENGTHTWO) {
                headerEl.removeChild(stripe[1]);
            }
            this.HOLD_TIME = document.getElementById('holdTime').value ? document.getElementById('holdTime').value : HOLD_TIME;
            this.TRANSITION_TIME = document.getElementById('transSpeed').value ? document.getElementById('transSpeed').value : TRANSITION_TIME;

            var loop = this.loop.bind(this),
                identifyAnalyticsPageType = this.identifyAnalyticsPageType.bind(this),
                breakpointSize = breakpoint.size(),
                pageFeature = document.getElementById('featureData') ? document.getElementById('featureData').innerText : false,
                userAgent = window.navigator.userAgent || window.navigator.vendor || window.opera,
                pageURL = window.location.href;

            this.stripeBar = document.querySelector('.navigation-sitestripe');
            this.pageType = document.getElementById('pageType') ? document.getElementById('pageType').innerText : false;
            this.slider = document.querySelector('.navigation-sitestripe__slider');
            this.slides = document.querySelectorAll('.navigation-sitestripe__slide');
            this.nextBtn = document.querySelector('.navigation-sitestripe__btn--next');
            this.previousBtn = document.querySelector('.navigation-sitestripe__btn--previous');
            this.defaultMsg = document.getElementById('defaultHdrStripeMsg');
            this.slideCount = this.slides.length;
            this.storeId = storeId;
            window.runhdrpromo = true;
            /*eslint func-style: ["error", "expression"]*/

            if (/iPad|iPhone|iPod/.test(userAgent) && !window.MSStream) {
                if (!breakpointSize || breakpointSize === '') {
                    breakpointSize = 'xsmall';
                }
            }

            this.pageType = (pageURL.indexOf('MSResLogin') !== -1) ? LOGIN : this.pageType;
            this.pageType = (pageURL.indexOf('OrderCalculate') !== -1) ? BASKET : this.pageType;
            this.pageType = (pageURL.indexOf('MSAgeCaptureCmd') !== -1) ? AGEVERIFY : this.pageType;

            pageFeature = (pageFeature && this.pageType) ? JSON.parse('{' + pageFeature + '"default":{}}') : false;
            var siteStripeKey = (pageFeature && pageFeature[this.pageType]) ? pageFeature[this.pageType].mobileSiteStripe : true;

            if (this.slideCount === 2) {
                this.slider.innerHTML += this.slider.innerHTML;
                this.slideCount = 4;
                this.slides = document.querySelectorAll('.navigation-sitestripe__slide');
            }
            for (var i = 0; i < this.slideCount; i++) {
                this.slides[i].style.transitionDuration = this.TRANSITION_TIME + 's';
                this.slides[i].firstElementChild.rankID = i + 1;
                if(this.slides[i].firstElementChild.href.indexOf('#intid') === -1) {
                    this.slides[i].firstElementChild.addEventListener('click', identifyAnalyticsPageType);
                }
            }
            if (this.defaultMsg && this.storeId === Constant.ieId) {
                this.slides[0].firstElementChild.href = '/ie/c/offers';
            }
            if (breakpointSize !== 'xsmall') {
                document.querySelector('.navigation-sitestripe').style.display = 'block';
            }
            window.siteStripeKey = siteStripeKey;
            if (breakpointSize === 'xsmall' && !siteStripeKey) {
                utils.addClass(document.querySelector('.navigation-sitestripe'), 'navigation-no-stripe');
            }
            if ((breakpointSize === 'xsmall' && siteStripeKey) || (breakpointSize !== 'xsmall')) {
                utils.addClass(this.slides[0], 'navigation-sitestripe__active');
                utils.removeClass(this.slider, 'navigation-sitestripe__loadslide');
                utils.addClass(document.querySelector('.navigation-nav-veil'), 'navigation-hdrstripe-adjust');
                this.slider.style.display = 'block';
                if (this.slideCount === 1) {
                    this.nextBtn.style.display = 'none';
                    this.previousBtn.style.display = 'none';
                    this.nextBtn.setAttribute('aria-hidden', true);
                    this.previousBtn.setAttribute('aria-hidden', true);
                    window.NavSingleInfinityLoop = true;
                    setTimeout(function () {
                        if (window.NavSingleInfinityLoop) {
                            var scrollW = document.querySelector('.navigation-sitestripe__slide.navigation-sitestripe__active a');
                            var offsetW = document.querySelector('.navigation-sitestripe__slide.navigation-sitestripe__active');
                            if (offsetW.offsetWidth < scrollW.scrollWidth) {
                                var navigationSitestripeStyle = document.createElement('style');
                                navigationSitestripeStyle.appendChild(document.createTextNode('@keyframes navigation-sitestripe_marquee {\
                            0% { transform: translateX('+ offsetW.offsetWidth + 'px); }\
                            100% { transform: translateX(-100%); }\
                        }'));
                                document.head.appendChild(navigationSitestripeStyle);
                                offsetW.classList.add('navigation-sitestripe__animation');
                            }

                        }
                    }, 300);
                    var visibleMsg = document.querySelector('.navigation-sitestripe__slide.navigation-sitestripe__active a');
                    visibleMsg.tabIndex = '0';
                    this.slider.style.overflow = 'visible';
                    this.slides[0].style.overflow = 'visible';
                    visibleMsg.style.width = 'fit-content';
                    if (this.slides[0].offsetWidth < visibleMsg.scrollWidth) {
                        var navigationSitestripeStyle = document.createElement('style');
                        navigationSitestripeStyle.appendChild(document.createTextNode('@keyframes navigation-sitestripe_marquee {\
                            0% { transform: translateX('+ this.slides[0].offsetWidth + 'px); }\
                            100% { transform: translateX(-100%); }\
                        }'));
                        document.head.appendChild(navigationSitestripeStyle);
                        this.slides[0].classList.add('navigation-sitestripe__animation');
                        window.NavSingleInfinityLoop = false;
                    }
                    else {
                        visibleMsg.style.width = '100%';
                        this.slides[0].style.overflow = 'hidden';
                        this.slider.style.overflow = 'hidden';
                    }

                }
                else if (this.slideCount >= 3) {
                    var timeInterval = this.HOLD_TIME * 1000;
                    this.slider.insertBefore(this.slides[this.slides.length - 1], this.slides[0]);
                    var aLinks = document.querySelectorAll('.navigation-sitestripe__slide a');
                    var visibleLink = document.querySelector('.navigation-sitestripe__slide.navigation-sitestripe__active a');
                    visibleLink.tabIndex = '0';
                    if (visibleLink.offsetWidth < visibleLink.scrollWidth) {
                        var scrollTime = parseInt(this.HOLD_TIME),
                            scrollDistance = -visibleLink.offsetWidth - visibleLink.scrollWidth,
                            transSpeed = parseInt(this.TRANSITION_TIME) + 1;
                        visibleLink.firstElementChild.style.transition = 'all ' + scrollTime + 's ease-in-out ' + transSpeed + 's';
                        visibleLink.firstElementChild.style.transform = 'translateX(' + scrollDistance + 'px)';
                    }

                    var Timer = this.Timer.bind(this);
                    var timer = new Timer(function () {
                        loop('auto');
                    }, timeInterval);

                    this.swipeDetect(this.stripeBar, function (swipeDirection) {
                        if (swipeDirection === 'left') {
                            timer.pause();
                            loop(NEXT);
                            timer.resume();
                        }
                        if (swipeDirection === 'right') {
                            timer.pause();
                            loop(PREV);
                            timer.resume();
                        }
                    });

                    this.nextBtn.addEventListener('click', function () {
                        loop(PREV);
                    });

                    this.previousBtn.addEventListener('click', function () {
                        loop(NEXT);
                    });
                    for (var ialinks = 0; ialinks < aLinks.length; ialinks++) {
                        aLinks[ialinks].addEventListener('blur', timer.resume);
                        aLinks[ialinks].addEventListener('focus', timer.pause);
                    }

                    this.slider.addEventListener('mouseover', timer.pause);

                    this.slider.addEventListener('mouseout', timer.resume);

                    this.nextBtn.addEventListener('mouseover', timer.pause);

                    this.nextBtn.addEventListener('mouseout', timer.resume);

                    this.previousBtn.addEventListener('mouseover', timer.pause);

                    this.previousBtn.addEventListener('mouseout', timer.resume);
                }
            }
        },

        loop: function (direction) {
            var slides = document.querySelectorAll('.navigation-sitestripe__slide'),
                holdTime = document.getElementById('holdTime').value ? document.getElementById('holdTime').value : HOLD_TIME,
                transSpeed = document.getElementById('transSpeed').value ? document.getElementById('transSpeed').value : TRANSITION_TIME,
                clickSpeed = document.getElementById('clickSpeed').value ? document.getElementById('clickSpeed').value : TRANSITION_TIME,
                activeSlide = document.querySelector('.navigation-sitestripe__slide.navigation-sitestripe__active');
            if (direction === NEXT || direction === PREV) {
                transSpeed = clickSpeed;
            }
            activeSlide.previousElementSibling.style.transitionDuration = transSpeed + 's';
            activeSlide.style.transitionDuration = transSpeed + 's';
            activeSlide.nextElementSibling.style.transitionDuration = transSpeed + 's';
            if (direction === NEXT || direction === 'auto') {
                slides[0].style.transitionDuration = 0 + 's';
                activeSlide.firstElementChild.tabIndex = '-1';
                this.slider.appendChild(slides[0]);
                activeSlide.classList.remove('navigation-sitestripe__active');
                activeSlide.nextElementSibling.classList.add('navigation-sitestripe__active');
                activeSlide.nextElementSibling.firstElementChild.tabIndex = '0';
            }
            else if (direction === PREV) {
                slides[slides.length - 1].style.transitionDuration = 0 + 's';
                activeSlide.firstElementChild.tabIndex = '-1';
                this.slider.insertBefore(slides[slides.length - 1], slides[0]);
                activeSlide.classList.remove('navigation-sitestripe__active');
                activeSlide.previousElementSibling.classList.add('navigation-sitestripe__active');
                activeSlide.previousElementSibling.firstElementChild.tabIndex = '0';
            }
            var activeLink = document.querySelector('.navigation-sitestripe__slide.navigation-sitestripe__active a');
            activeLink.firstElementChild.removeAttribute('style');
            if (activeLink.offsetWidth < activeLink.scrollWidth && window.runhdrpromo) {
                var scrollTime = parseInt(holdTime),
                    scrollDistance = -activeLink.offsetWidth - activeLink.scrollWidth;
                transSpeed = parseInt(transSpeed) + 1;
                activeLink.firstElementChild.style.transition = 'all ' + scrollTime + 's ease-in-out ' + transSpeed + 's';
                activeLink.firstElementChild.style.transform = 'translateX(' + scrollDistance + 'px)';
            }
        },

        identifyAnalyticsPageType: function () {
            var pageURL = window.location.href,
                analyticsPageType = 'other';
            if (pageURL.indexOf('MSResLogin') !== -1) {
                analyticsPageType = 'login';
            }
            else if (pageURL.indexOf('MSSinglePageCheckoutCmd') !== -1) {
                analyticsPageType = 'spc';
            }
            else if (pageURL.indexOf('MSResUserRegistration') !== -1) {
                analyticsPageType = 'reg';
            }
            else if (pageURL.indexOf('MSPaymentDisplayCmd') !== -1) {
                analyticsPageType = 'pay';
            }
            else if (pageURL.indexOf('MSOrderReviewDisplayCmd') !== -1) {
                analyticsPageType = 'ordreview';
            }
            else if (pageURL.indexOf('MSResOrderConfirmationCmd') !== -1) {
                analyticsPageType = 'ordconf';
            }
            else if ((pageURL.indexOf('MSContactAddressDisplayCmd') !== -1) || (pageURL.indexOf('MSAgeCaptureCmd') !== -1)) {
                analyticsPageType = 'chkout';
            }
            else if (this.pageType === 'DLPFESK' || this.pageType === 'DLP_NONFEAR') {
                analyticsPageType = 'dlp';
            }
            else if (this.pageType) {
                analyticsPageType = this.pageType.toLowerCase();
            }

            var aTag = document.querySelector('.navigation-sitestripe__slide.navigation-sitestripe__active a');
            var locSplit = aTag.dataset.href.split('?'),
                message = aTag.innerText.replace(/ /g, '-'),
                locSearch = [],
                newSearch = [];
            message = message.replace(/[^a-zA-Z0-9- ]/g, '');

            if (locSplit.length > 1) {
                locSearch = locSplit[1];
                if (locSearch.indexOf('intid=') > -1) { // remove existing intid
                    var params = locSearch.split('&');
                    for (var ind = 0; ind < params.length; ind++) {
                        if (params[ind].indexOf('intid=') === -1) {
                            newSearch.push(params[ind]);
                        }
                    }
                    locSearch = newSearch.join('&'); // rebuild query params without intid
                }
                aTag.href = locSplit[0] + '?' + locSearch + '#intid=' + analyticsPageType + '_stripe_' + aTag.rankID + '_' + message.substring(0, 20);
            } else if (locSplit.length === 1) {
                if (locSplit[0].indexOf('#intid') > -1) {
                    locSplit[0] = locSplit[0].split('#intid')[0];
                }
                aTag.href = locSplit[0] + '#intid=' + analyticsPageType + '_stripe_' + aTag.rankID + '_' + message.substring(0, 20);
            }
            return true;
        },

        swipeDetect: function (el, callback) {
            var touchsurface = el,
                swipeDirection,
                startX,
                startY,
                distX,
                distY,
                threshold = 50, //required min distance traveled to be considered swipe
                restraint = 50, // maximum distance allowed at the same time in perpendicular direction
                allowedTime = 300, // maximum time allowed to travel that distance
                elapsedTime,
                startTime,
                handleSwipe = callback;

            touchsurface.addEventListener('touchstart', function (e) {
                var touchobj = e.changedTouches[0];
                swipeDirection = 'none';
                startX = touchobj.pageX;
                startY = touchobj.pageY;
                startTime = new Date().getTime(); // record time when finger first makes contact with surface
            }, false);

            touchsurface.addEventListener('touchmove', function (e) {
                e.preventDefault();
            }, false);

            touchsurface.addEventListener('touchend', function (e) {
                var touchobj = e.changedTouches[0];
                distX = touchobj.pageX - startX; // get horizontal dist traveled by finger while in contact with surface
                distY = touchobj.pageY - startY; // get vertical dist traveled by finger while in contact with surface
                elapsedTime = new Date().getTime() - startTime; // get time elapsed
                if (elapsedTime <= allowedTime) { // first condition for awipe met
                    if (Math.abs(distX) >= threshold && Math.abs(distY) <= restraint) { // 2nd condition for horizontal swipe met
                        swipeDirection = (distX < 0) ? 'left' : 'right'; // if dist traveled is negative, it indicates left swipe
                    }
                    else if (Math.abs(distY) >= threshold && Math.abs(distX) <= restraint) { // 2nd condition for vertical swipe met
                        swipeDirection = (distY < 0) ? 'up' : 'down'; // if dist traveled is negative, it indicates up swipe
                    }
                }
                handleSwipe(swipeDirection);
            }, false);
        },

        Timer: function (callback, delay) {
            var timerId, visibleLink;

            this.pause = function () {
                window.clearInterval(timerId);
                window.runhdrpromo = false;
                visibleLink = document.querySelector('.navigation-sitestripe__slide.navigation-sitestripe__active a');
                visibleLink.firstElementChild.removeAttribute('style');
            };

            this.resume = function () {
                var holdTime = document.getElementById('holdTime').value ? document.getElementById('holdTime').value : HOLD_TIME;
                var transitionSpeed = document.getElementById('transSpeed').value ? document.getElementById('transSpeed').value : TRANSITION_TIME;
                visibleLink = document.querySelector('.navigation-sitestripe__slide.navigation-sitestripe__active a');
                if (visibleLink.offsetWidth < visibleLink.scrollWidth) {
                    var scrollTime = parseInt(holdTime),
                        scrollDistance = -visibleLink.offsetWidth - visibleLink.scrollWidth,
                        transSpeed = parseInt(transitionSpeed) + 1;
                    visibleLink.firstElementChild.style.transition = 'all ' + scrollTime + 's ease-in-out ' + transSpeed + 's';
                    visibleLink.firstElementChild.style.transform = 'translateX(' + scrollDistance + 'px)';
                }
                window.runhdrpromo = true;
                window.clearInterval(timerId);
                timerId = window.setInterval(callback, delay);
            };

            this.resume();
        }
    };
});



// WEBPACK FOOTER //
// ./src/mns-core-ui-header/templates/header/js/HdrSiteStripe.js